import React, { useRef, useEffect } from "react";
import styles from './IndividualParticipantContent.module.css';
import logo from '../../assets/les-logo.png';
import { FaGithub, FaEnvelope, FaLinkedin } from 'react-icons/fa';
import ProjectCarousel from '../ProjectCarousel/ProjectCarousel';
import PublicationCarousel from '../PublicationCarousel/PublicationCarousel';
import Extensions from '../Extensions/Extensions';

export default function IndividualProjectPage() {

    return (
        <div className={styles["individual-participant"]}>

            <section className={styles['info-container']}>

                <div className={styles.detailInfoContainer}>
                    <div className={styles['participant-info']}> 

                        <div data-testid="participant-name" className={styles['participant-name']}>
                            <h1>Nome do Partipante</h1>
                        </div>

                        <div className={styles['participant-status']}>
                            egresso
                        </div>
                    </div>

                    <div className={styles['participant-ocupation']}>
                        <h5> atualmente: </h5>

                        <p> empresa x </p>

                        <p> (2023) </p>
                        
                    </div>
                    
                    <div className={styles.icons}>
                        <FaEnvelope className={styles['icon']} size={40} data-testid="envelope-icon" />
                        <FaGithub className={styles['icon']} size={40} data-testid="github-icon" />
                        <FaLinkedin className={styles['last-icon']} size={40} data-testid="linkedin-icon" />
                    </div>
                </div>

                
                <div className={styles.perfilImageContainer}>
                    <img src={logo} alt="perfilImage" className={styles.perfilImage}/>
                </div>

            </section>

            <section className={styles['carousel-container']}>
                    <section className={styles["projects-container"]}> 
                        <h2>PROJETOS</h2>

                        <div data-testid="project-carousel" className={styles["projects-carousel"]}> 
                            <ProjectCarousel />
                        </div>
                    </section>

                    <section className={styles["publications-container"]}> 
                        <h2>PUBLICAÇÕES</h2>

                        <div data-testid="publication-carousel" className={styles["publications-carousel"]}>
                            <PublicationCarousel />
                        </div>
                    </section>

                    <section className={styles["extensions-container"]}>
                    
                        <h2>EXTENSÕES</h2>

                        <div data-testid="extensions-carousel" className={styles["extensions-carousel"]}>
                            <Extensions />
                        </div>
                    </section>
            </section>

        </div>

    );
}

